import _ from 'underscore';
import {
    UPDATE_INPUT_FUEL_RECORD,
    UPDATE_INPUT_BILL_PHOTO_URL,
    CLEAR_ONE_FUEL_RECORD,
    SET_RECORD_TO_ONE_FUEL_RECORD,
} from '../actions/types';

export default function (state = {}, action) {
    switch (action.type) {
        case UPDATE_INPUT_FUEL_RECORD:
            return _.extend({}, state, action.payload);
        case UPDATE_INPUT_BILL_PHOTO_URL:
            return _.extend({}, state, action.payload);
        case CLEAR_ONE_FUEL_RECORD:
            return action.payload;
        case SET_RECORD_TO_ONE_FUEL_RECORD:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/one_fuel_record_reducer.js